import { ComponentProps } from "react";
import { IMutator } from "sonobello.utilities.react";

import { DisqualReason } from "../../../../Utils/Enums";
import SessionCacheStateProvider from "../../../Providers/State/SessionCacheStateProvider";
import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import ComposableMedicalForm, { IComposableMedicalFormProps } from "../Components/ComposableMedicalForm";
import ComposableMedicalStep from "../Components/ComposableMedicalStep";
import MedicalFormState from "../Types/MedicalFormState";
import { FormItems, MedicalFormInterpreter } from "./ComposedMedicalFormQuestions";

const uncachedMedicalForm: React.FC<Pick<IComposableMedicalFormProps, "onChange" | "value">> = props =>
  ComposableMedicalForm({ ...props, formItems: FormItems });

const medicalFormLocalStorageKey = "medical_form";

/** The composed {@link ComposableMedicalForm} with its state synced to the browser's localstorage. */
const BrowserCachingMedicalForm = SessionCacheStateProvider<
  MedicalFormState,
  ComponentProps<typeof uncachedMedicalForm>
>({
  Component: uncachedMedicalForm,
  localStoreKey: medicalFormLocalStorageKey
});

const MedicalStepWithForm: React.FC<IMutator<boolean>> = props =>
  ComposableMedicalStep({
    ...props,
    medicalFormInterpreter: MedicalFormInterpreter,
    MedicalForm: BrowserCachingMedicalForm
  });

/** The composed {@link ComposableMedicalStep} with its change handler provided by the session context. */
const ComposedMedicalStep: React.FC = SessionContextValueProvider<
  ComponentProps<typeof MedicalStepWithForm>,
  ComponentProps<typeof MedicalStepWithForm>
>({
  Component: MedicalStepWithForm,
  map: ({ helpers: { qualify } }) => ({ onChange: newValue => qualify(DisqualReason.MedicalNonCandidate, newValue) })
});

export default ComposedMedicalStep;
